import { Box, Stack } from '@mui/material';

import ReportsTable from '../../components/customer/reports/reportsTable';

const CustomerReportsList = () => {

  return (
    <Stack>
      <Box>
        <Box sx={{ flexGrow: 1 }}><ReportsTable /></Box>
      </Box>
    </Stack>
  );
};

export default CustomerReportsList;
